export { default } from './MediaTabLabel';
